React = require 'react'
$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
l = require 'app/scripts/lib/localize'
log = require 'app/scripts/debug/log'
_ = require 'underscore'
Promise = require 'bluebird'
Util = require 'app/scripts/lib/util'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ renderTopLevelComponent } = require 'app/scripts/controller/renderTopLevelComponent'
{ LazyTemplatesGallery } = require 'app/src/components/TemplatesGallery'
{ ShortcutsOverlay } = require 'app/src/components/ShortcutsOverlay'
{ ShortcutsPage } = require 'app/src/components/ShortcutsPage'

module.exports =
  routes: [
    ['shortcuts', 'shortcutsView']
    ['shortcuts/overlay', 'shortcutsViewOverlay']
    ['blank', 'blankView']
    ['select-org-to-upgrade', 'businessClassSelectOrgView']
    ['select-team-to-upgrade', 'businessClassSelectTeamView']
    ['search(?*query)', 'searchView']
    ['templates', 'templatesGallery']
  ]

  businessClassSelectOrgView: ->
    @navigate '/select-team-to-upgrade', replace: true, trigger: true
    return

  businessClassSelectTeamView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BusinessClassSelectOrgView = require 'app/scripts/views/organization/business-class-select-org-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    pathname = '/select-team-to-upgrade'

    if !Auth.isLoggedIn()
      window.location = "/login?returnUrl=#{ pathname }"
      return

    Promise.using @getSpinner(), =>
      ModelLoader.for('top-level', 'loadMyOrganizationsWithoutBoards').then (member) =>
        @setViewType('select-org')

        notPremiumOrgs = _.filter(member.organizationList.models, (org) -> !org.isPremium())
        if notPremiumOrgs.length == 1
          @navigate "/#{ notPremiumOrgs[0].get('name') }/billing", { trigger: true }
          return

        @setLocation
          title: l('select organization to upgrade to business class')
          location: pathname

        @clearPreviousView()
        view = @topLevelView(BusinessClassSelectOrgView, member)

        @showHeader()
        $('#content').html view.render().el
    .done()

  searchView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SearchInputView = require 'app/scripts/views/search/search-input-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SearchState = require 'app/scripts/view-models/search-state'

    log('controller', ['searchView'])

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        if !Auth.isLoggedIn()
          @displayErrorPage()
          return

        @setViewType('search')
        @clearPreviousView()
        me = Auth.me()
        headerCache = ModelCache

        query = Util.getQueryParameter('q', "")
        inputView = @topLevelView(SearchInputView, me, modelCache: headerCache)
        resultsView = inputView.getResultsView()

        SearchState.setQuery(query)
        resultsView.update()
        @showHeader({ noSearch: true })

        $('#trello-root').addClass('body-search-page')

        $('#content')
        .append(inputView.render().el)
        .append(resultsView.render().el)

        _.defer -> inputView.focusInput()
        return
    .done()

  blankView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('blank')
        @clearPreviousView()
        @showHeader()
        return
    .done()

  shortcutsViewOverlay: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Dialog = require 'app/scripts/views/lib/dialog'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    ModelLoader.await 'headerData'
    .then =>
      title = l('keyboard shortcuts')
      location = 'shortcuts/overlay'

      if @onAnyBoardView()
        @saveBoardsView()
        Dialog.show
          reactElement: React.createElement ShortcutsOverlay,
            onClose: ->
              Dialog.hide()
          maxWidth: 550
          hide: (isNavigating) =>
            if !isNavigating
              @loadBoardsView()
        @setLocation(title, location)
      else
        @navigate '/shortcuts', replace: true, trigger: true

    return

  shortcutsView: ->
    title = l('keyboard shortcuts')
    location = 'shortcuts'

    if @onAnyBoardView()
      @navigate '/shortcuts/overlay', replace: true, trigger: true
    else
      log('controller', [location + 'View'])
      renderTopLevelComponent(React.createElement(ShortcutsPage))
      .then =>
        $('#trello-root').addClass('body-single-column')
        @focusContent()
        @setLocation({ title, location })

  templatesGallery: ->
    if featureFlagClient.get('templates.public-gallery', false)
      renderTopLevelComponent(React.createElement(LazyTemplatesGallery))
    else
      @navigate '/', replace: true, trigger: true

  errorView: ({ title, location, data }) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ErrorView = require 'app/scripts/views/error/error-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    Promise.using @getSpinner(), =>
      ModelLoader.await('headerData').then =>
        @setViewType('error')
        @clearPreviousView()
        @showHeader()

        fullName = Auth.me()?.get('fullName') ? ''

        _.extend data, { fullName: fullName }

        errorView = @topLevelView(ErrorView, data)
        $('#content').append(errorView.render().el)
        @focusContent()

        @setLocation({ title, location })
    .done()
